import RatingList from '_modules/rating/views/RatingList.vue';
import RatingQuestions from '_modules/rating/views/RatingQuestions.vue';
import RatingUserAnswer from '_modules/rating/views/RatingUserAnswer.vue';
import RatingAnswersList from '_modules/rating/views/RatingAnswersList.vue';
import RatingTicketAnswersList from '_modules/rating/views/RatingTicketAnswersList.vue';
import Rating from './Root.vue';


export default {
  path: 'avaliacao/',
  component: Rating,
  name: 'admin-rating',
  redirect: '/avaliacao/1',
  children: [
    {
      path: 'lista',
      name: 'admin-rating-list',
      component: RatingList,
    },
    {
      path: ':ratingId',
      name: 'admin-rating-edit',
      component: RatingQuestions,
    },
    {
      path: 'respostas/chamado/:page',
      name: 'admin-rating-answers-tickets',
      component: RatingTicketAnswersList,
    },
    {
      path: 'respostas/obra/:page',
      name: 'admin-rating-answers-projects',
      component: RatingAnswersList,
    },
    {
      path: 'user/:userId',
      name: 'admin-rating-user',
      component: RatingUserAnswer,
    },
  ],
};
